/** The variant key a column without its own `optionKey` saves under. */
export const DEFAULT_VARIANT_KEY = "variant";

/**
 * The saved values a column's variant is read from, in order:
 * `customVariants[optionKey]` (written by the variant menu), then, for the
 * default key, the legacy top-level `variant` mirror kept for views saved
 * before `customVariants` existed. ViewTable and DataGrid both read through it.
 */
export const getSavedVariantCandidates = ({
    customVariants,
    legacyVariant,
    optionKey,
}: {
    customVariants: Partial<Record<string, string>> | null | undefined;
    legacyVariant: string | null | undefined;
    optionKey: string;
}) => [
    customVariants?.[optionKey],
    optionKey === DEFAULT_VARIANT_KEY ? legacyVariant : undefined,
];
